<template>
  <v-container>
    <v-container class="ma-0 pa-0 d-flex">
      <h1>База новостроек</h1>
    </v-container>

    <v-container class="ma-0 pa-0 mt-2">
      <v-data-table
        :headers="tableHeaders"
        :items="buildings"
        item-key="_id"
        class="elevation-1"
        :loading="loading"
        loading-text="Данные загружаются... Пожалуйста, подождите."
        :key="searchId"
      >
        <template v-slot:top>
          <v-row no-gutters>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="text"
                placeholder="Поиск по id, адресу, названию ЖК, застройщику"
                class="pl-4 pr-4"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="pt-3">
              <v-btn color="primary" @click="search()">Искать</v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.id`]="{item}">
          <building-card :value="item"></building-card>
        </template>
      </v-data-table>
      <v-alert class="mt-3" type="warning" outlined dense v-if="count != buildings.length">
        <small>Показаны первые {{ buildings.length }} записей (всего найдено {{ count }}).
        Для просмотра остальных уточните критерии поиска с помощью фильтра.</small>
      </v-alert>
    </v-container>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import BuildingCard from '../components/buildings/BuildingCard';
import { getTempId } from '../models/common';


export default {
  components: {
    BuildingCard
  },

  data() {
    return {
      searchId: getTempId(),
      text: '',
      tableHeaders: [
        {
          text: 'ID',
          value: 'id'
        },
        {
          text: 'Адрес дома',
          value: 'name'
        },
        {
          text: 'Застройщик',
          value: 'company'
        }
      ]
    }
  },

  created() {
    this.$store.dispatch('buildings/loadList');
  },

  methods: {
    search() {
      this.searchId = getTempId();
      this.$store.dispatch('buildings/loadList', this.text);
    }
  },

  computed: {
    ...mapState('buildings', ['count', 'buildings', 'loading'])
  }
}
</script>